import PropTypes from 'prop-types';
import React from 'react';
import styles from './Notice.module.css';

function Notice({ type = 'info', children }) {
  let icon;
  switch (type) {
    case 'success':
      icon = (
        <svg
          className={styles.icon}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0013 1.6665C5.41797 1.6665 1.66797 5.4165 1.66797 9.99984C1.66797 14.5832 5.41797 18.3332 10.0013 18.3332C14.5846 18.3332 18.3346 14.5832 18.3346 9.99984C18.3346 5.4165 14.5846 1.6665 10.0013 1.6665ZM13.5013 8.58317L9.5013 12.5832C9.16797 12.9165 8.66797 12.9165 8.33464 12.5832L6.5013 10.7498C6.16797 10.4165 6.16797 9.9165 6.5013 9.58317C6.83464 9.24984 7.33464 9.24984 7.66797 9.58317L8.91797 10.8332L12.3346 7.4165C12.668 7.08317 13.168 7.08317 13.5013 7.4165C13.8346 7.74984 13.8346 8.24984 13.5013 8.58317Z"
            fill="#04724D"
          />
        </svg>
      );
      break;
    case 'error':
      icon = (
        <svg
          className={styles.icon}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0013 1.6665C5.41797 1.6665 1.66797 5.4165 1.66797 9.99984C1.66797 14.5832 5.41797 18.3332 10.0013 18.3332C14.5846 18.3332 18.3346 14.5832 18.3346 9.99984C18.3346 5.4165 14.5846 1.6665 10.0013 1.6665ZM13.0846 11.9165C13.418 12.2498 13.418 12.7498 13.0846 13.0832C12.7513 13.4165 12.2513 13.4165 11.918 13.0832L10.0013 11.1665L8.08464 13.0832C7.7513 13.4165 7.2513 13.4165 6.91797 13.0832C6.58464 12.7498 6.58464 12.2498 6.91797 11.9165L8.83464 9.99984L6.91797 8.08317C6.58464 7.74984 6.58464 7.24984 6.91797 6.9165C7.2513 6.58317 7.7513 6.58317 8.08464 6.9165L10.0013 8.83317L11.918 6.9165C12.2513 6.58317 12.7513 6.58317 13.0846 6.9165C13.418 7.24984 13.418 7.74984 13.0846 8.08317L11.168 9.99984L13.0846 11.9165Z"
            fill="#BA2532"
          />
        </svg>
      );
      break;
    case 'warning':
      icon = (
        <svg
          className={styles.icon}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0013 5.83317C9.78029 5.83317 9.56833 5.92097 9.41205 6.07725C9.25577 6.23353 9.16797 6.44549 9.16797 6.6665V9.99984C9.16797 10.2209 9.25577 10.4328 9.41205 10.5891C9.56833 10.7454 9.78029 10.8332 10.0013 10.8332C10.2223 10.8332 10.4343 10.7454 10.5906 10.5891C10.7468 10.4328 10.8346 10.2209 10.8346 9.99984V6.6665C10.8346 6.44549 10.7468 6.23353 10.5906 6.07725C10.4343 5.92097 10.2223 5.83317 10.0013 5.83317ZM10.0013 12.4998C9.83648 12.4998 9.67537 12.5487 9.53833 12.6403C9.40129 12.7318 9.29448 12.862 9.2314 13.0143C9.16833 13.1665 9.15183 13.3341 9.18398 13.4957C9.21614 13.6574 9.2955 13.8059 9.41205 13.9224C9.52859 14.039 9.67708 14.1183 9.83873 14.1505C10.0004 14.1826 10.1679 14.1661 10.3202 14.1031C10.4725 14.04 10.6026 13.9332 10.6942 13.7961C10.7858 13.6591 10.8346 13.498 10.8346 13.3332C10.8346 13.1122 10.7468 12.9002 10.5906 12.7439C10.4343 12.5876 10.2223 12.4998 10.0013 12.4998ZM18.093 6.29984L13.7013 1.90817C13.5416 1.75589 13.3303 1.66957 13.1096 1.6665H6.89297C6.67233 1.66957 6.461 1.75589 6.3013 1.90817L1.90964 6.29984C1.75736 6.45953 1.67104 6.67087 1.66797 6.8915V13.1082C1.67104 13.3288 1.75736 13.5401 1.90964 13.6998L6.3013 18.0915C6.461 18.2438 6.67233 18.3301 6.89297 18.3332H13.1096C13.3303 18.3301 13.5416 18.2438 13.7013 18.0915L18.093 13.6998C18.2452 13.5401 18.3316 13.3288 18.3346 13.1082V6.8915C18.3316 6.67087 18.2452 6.45953 18.093 6.29984ZM16.668 12.7582L12.7596 16.6665H7.24297L3.33464 12.7582V7.2415L7.24297 3.33317H12.7596L16.668 7.2415V12.7582Z"
            fill="#96530F"
          />
        </svg>
      );
      break;
    default:
      // info
      icon = (
        <svg
          className={styles.icon}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0013 9.1665C9.78029 9.1665 9.56833 9.2543 9.41205 9.41058C9.25577 9.56686 9.16797 9.77882 9.16797 9.99984V13.3332C9.16797 13.5542 9.25577 13.7661 9.41205 13.9224C9.56833 14.0787 9.78029 14.1665 10.0013 14.1665C10.2223 14.1665 10.4343 14.0787 10.5906 13.9224C10.7468 13.7661 10.8346 13.5542 10.8346 13.3332V9.99984C10.8346 9.77882 10.7468 9.56686 10.5906 9.41058C10.4343 9.2543 10.2223 9.1665 10.0013 9.1665ZM10.318 5.89984C10.1151 5.81649 9.88752 5.81649 9.68464 5.89984C9.58235 5.9395 9.48889 5.99897 9.40964 6.07484C9.33603 6.15584 9.27684 6.24885 9.23464 6.34984C9.18799 6.44874 9.16516 6.55719 9.16797 6.6665C9.16734 6.77618 9.18836 6.88489 9.22983 6.98643C9.2713 7.08796 9.3324 7.1803 9.40964 7.25817C9.49064 7.33178 9.58365 7.39097 9.68464 7.43317C9.81089 7.48504 9.94794 7.5051 10.0838 7.4916C10.2196 7.47809 10.35 7.43144 10.4636 7.35573C10.5771 7.28002 10.6704 7.17757 10.7351 7.0574C10.7998 6.93722 10.834 6.80299 10.8346 6.6665C10.8316 6.44587 10.7453 6.23453 10.593 6.07484C10.5137 5.99897 10.4203 5.9395 10.318 5.89984ZM10.0013 1.6665C8.35313 1.6665 6.74196 2.15525 5.37155 3.07092C4.00114 3.9866 2.93304 5.28809 2.30231 6.81081C1.67158 8.33353 1.50655 10.0091 1.8281 11.6256C2.14964 13.2421 2.94331 14.727 4.10875 15.8924C5.27419 17.0578 6.75905 17.8515 8.37555 18.173C9.99206 18.4946 11.6676 18.3296 13.1903 17.6988C14.7131 17.0681 16.0145 16 16.9302 14.6296C17.8459 13.2592 18.3346 11.648 18.3346 9.99984C18.3346 8.90549 18.1191 7.82186 17.7003 6.81081C17.2815 5.79976 16.6677 4.8811 15.8939 4.10728C15.12 3.33346 14.2014 2.71963 13.1903 2.30084C12.1793 1.88205 11.0957 1.6665 10.0013 1.6665ZM10.0013 16.6665C8.68276 16.6665 7.39383 16.2755 6.2975 15.543C5.20118 14.8104 4.34669 13.7692 3.84211 12.5511C3.33752 11.3329 3.2055 9.99244 3.46274 8.69924C3.71997 7.40603 4.35491 6.21814 5.28726 5.28579C6.21961 4.35344 7.4075 3.7185 8.7007 3.46127C9.99391 3.20403 11.3344 3.33606 12.5525 3.84064C13.7707 4.34522 14.8119 5.19971 15.5444 6.29604C16.277 7.39236 16.668 8.6813 16.668 9.99984C16.668 11.7679 15.9656 13.4636 14.7154 14.7139C13.4651 15.9641 11.7694 16.6665 10.0013 16.6665Z"
            fill="#4338CA"
          />
        </svg>
      );
  }
  return (
    <div className={`${styles.notice} ${styles[type]}`}>
      {icon}
      <div className={styles.noticeText}>{children}</div>
    </div>
  );
}

Notice.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
  children: PropTypes.node.isRequired,
};

export default Notice;
